import React, { useEffect, useRef, useState } from 'react';
import {
  ERP_SESSION_REPLACED_EVENT,
  ERP_SESSION_REPLACED_MESSAGE
} from '../services/erpSessionClient';

function SessionReplacedNotice({ onSessionReplaced, onAcknowledge }) {
  const [reason, setReason] = useState(null);
  const acknowledgeRef = useRef(null);

  useEffect(() => {
    const receiveReplacement = () => {
      // A mensagem exibida e fixa. Eventos nunca transportam bearer, CSRF,
      // usuario ou tenant para este componente.
      onSessionReplaced?.();
      setReason('replaced');
    };
    const receiveEnded = () => {
      onSessionReplaced?.();
      setReason('ended');
    };
    window.addEventListener(ERP_SESSION_REPLACED_EVENT, receiveReplacement);
    const unsubscribeReplacement = window.electron?.auth?.onCentralSessionReplaced?.(receiveReplacement);
    const unsubscribeEnded = window.electron?.auth?.onCentralSessionEnded?.(receiveEnded);
    return () => {
      window.removeEventListener(ERP_SESSION_REPLACED_EVENT, receiveReplacement);
      unsubscribeReplacement?.();
      unsubscribeEnded?.();
    };
  }, [onSessionReplaced]);

  useEffect(() => {
    if (reason) acknowledgeRef.current?.focus();
  }, [reason]);

  if (!reason) return null;

  const acknowledge = () => {
    setReason(null);
    onAcknowledge?.();
  };
  const description = reason === 'replaced'
    ? ERP_SESSION_REPLACED_MESSAGE
    : 'A sessão central terminou ou perdeu a conexão necessária. Entre novamente.';
  const guidance = reason === 'replaced'
    ? 'Por segurança, este acesso foi desconectado. Entre novamente apenas se quiser usar este dispositivo.'
    : 'A licença offline segura não estava disponível ou a sessão expirou. Entre novamente para renovar o acesso deste computador.';

  return (
    <div className="session-replaced-backdrop" role="presentation">
      <section
        className="session-replaced-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-replaced-title"
        aria-describedby="session-replaced-description"
      >
        <span className="session-replaced-icon" aria-hidden="true">
          <i className="fas fa-user-shield" />
        </span>
        <div>
          <h2 id="session-replaced-title">Sessão encerrada</h2>
          <p id="session-replaced-description">{description}</p>
          <p className="session-replaced-guidance">{guidance}</p>
        </div>
        <button ref={acknowledgeRef} type="button" className="btn btn-primary" onClick={acknowledge}>
          Ir para o login
        </button>
      </section>
    </div>
  );
}

export default SessionReplacedNotice;
